module.exports = angular.module("tf.strategy.options", [])
                        .service("optionService", ["chainService", "$http", optionService])
    .name;

function optionService(chainService, $http) {

    var cachedOptionService = null;
    var lastUnderlying = null;

    function changeWhatIfTrade(position, nextOption, trades) {
        position = Object.assign({}, position);
        for (var i = 0; i < trades.length; i++) {
            var trade = trades[i];
            if (trade.id === position.id) {
                trade.code = nextOption.code;
            }
        }

        // This is pre-changing the UI based on what we expect it to be
        position.code = nextOption.code;
        position.strike = nextOption.strike;
        position.type = nextOption.type;
        position.style = nextOption.style;
        position.expiry = nextOption.expiry;
        // Clear out these values as they are wrong until the new values are known
        position.theoPrice = null;
        position.vol = null;
        position.netDelta = null;
        position.premium = null;

        return position;
    }

    function moveStrikesUp(underlying, tradeDetails, trades) {
        return shiftStrikes(underlying, tradeDetails, true, trades);
    }

    function moveStrikesDown(underlying, tradeDetails, trades) {
        return shiftStrikes(underlying, tradeDetails, false, trades);
    }

    function shiftStrikes(underlying, positions, widen, trades) {
        if (!cachedOptionService || lastUnderlying !== underlying) {
            cachedOptionService = chainService(underlying);
            lastUnderlying = underlying;
        }
        return cachedOptionService.then(function (chain) {

            return $http.get("/tradefloor/api/prices/" + underlying).then(function (response) {

                var currentPrice = response.data.price;

                return positions.map(function (position) {

                    position = Object.assign({}, position);

                    var option = chain.codes[position.code];

                    var itm;
                    var call;

                    if (option.type === "CALL") {
                        call = true;
                        itm = currentPrice > option.strike;
                    } else if (option.type === "PUT") {
                        call = true;
                        itm = currentPrice < option.strike;
                    } else {
                        return position;
                    }

                    var down = itm != call != widen;


                    var rung = option.rung;
                    var nextRung = down ? rung.previousRung : rung.nextRung;

                    if (!nextRung) {
                        return position;
                    }

                    var nextItm;
                    var nextOption;

                    if (option.type === "CALL") {
                        nextOption = nextRung.call;
                        nextItm = currentPrice > nextRung.level;
                    } else if (option.type === "PUT") {
                        nextOption = nextRung.put;
                        nextItm = currentPrice < nextRung.level;
                    }

                    if (!nextOption) {
                        return position;
                    }

                    if (nextItm !== itm) {
                        return position;
                    }

                    return changeWhatIfTrade(position, nextOption, trades);
                });
            });
        });
    }

    function moveExpiriesOut(underlying, tradeDetails, trades) {
        return shiftExpiries(underlying, tradeDetails, true, trades);
    }

    function moveExpiriesIn(underlying, tradeDetails, trades) {
        return shiftExpiries(underlying, tradeDetails, false, trades);
    }

    function shiftExpiries(underlying, positions, up, trades) {
        if (!cachedOptionService || lastUnderlying !== underlying) {
            cachedOptionService = chainService(underlying);
            lastUnderlying = underlying;
        }

        return cachedOptionService.then(function (chain) {

            return positions.map(function (position) {

                position = Object.assign({}, position);

                var option = chain.codes[position.code];

                var nextRung;

                var series = option.series;
                var nextSeries = up ? series.nextSeries : series.previousSeries;

                if (!nextSeries) {
                    return position;
                }

                nextRung = nextSeries.rungAtOrAfter(option.strike);

                if (!nextRung) {
                    return position;
                }

                var nextOption;
                if (option.type === "CALL") {
                    nextOption = nextRung.call;
                } else if (option.type === "PUT") {
                    nextOption = nextRung.put;
                }

                if (!nextOption) {
                    return position;
                }

                return changeWhatIfTrade(position, nextOption, trades);
            });
        });
    }

    function tickOption(position, code, strike, monthMove, up, trades) {
        position = Object.assign({}, position);
        if (!cachedOptionService || lastUnderlying !== position.security) {
            cachedOptionService = chainService(position.security);
            lastUnderlying = position.security;
        }
        return cachedOptionService.then(function (chain) {
            var option = chain.codes[code];

            var nextRung;

            if (monthMove) {
                var series = option.series;
                var nextSeries = up ? series.nextSeries : series.previousSeries;

                if (!nextSeries) {
                    return position;
                }

                nextRung = nextSeries.rungAtOrAfter(strike);
            } else {
                var rung = option.rung;
                nextRung = up ? rung.nextRung : rung.previousRung;
            }


            if (!nextRung) {
                return position;
            }

            var nextOption;
            if (option.type === "CALL") {
                nextOption = nextRung.call;
            } else if (option.type === "PUT") {
                nextOption = nextRung.put;
            }

            if (!nextOption) {
                return position;
            }

            var exists = trades.some(function (trade) {
                return trade.code === nextOption.code;
            });

            if (exists) {
                return tickOption(position, nextOption.code, nextOption.strike, monthMove, up, trades);
            }
            return changeWhatIfTrade(position, nextOption, true);
        });
    }

    function nextStrike(position, trades) {
        return tickOption(position, position.code, position.strike, false, true, trades);
    }

    function previousStrike(position, trades) {
        return tickOption(position, position.code, position.strike, false, false, trades);
    }

    function nextExpiry(position, trades) {
        return tickOption(position, position.code, position.strike, true, true, trades);
    }

    function previousExpiry(position, trades) {
        return tickOption(position, position.code, position.strike, true, false, trades);
    }

    async function rollPosition(position) {
        const chain = await chainService(position.security);
        const nextSeries = chain.codes[position.code].series.nextSeries;

        if (nextSeries) {
            const rung = nextSeries.rungAtOrAfter(position.strike);
            const newInstrument = position.type === "PUT" ? rung.put : rung.call;

            if (newInstrument != null) {
                return {
                    code: newInstrument.code,
                    quantity: -position.quantity
                };
            } else {
                throw Error(`Unable to Roll Position: ${position.code}`)
            }
        }
    }

    return {
        changeWhatIfTrade: changeWhatIfTrade,
        moveStrikesUp: moveStrikesUp,
        moveStrikesDown: moveStrikesDown,
        shiftStrikes: shiftStrikes,
        moveExpiriesOut: moveExpiriesOut,
        moveExpiriesIn: moveExpiriesIn,
        shiftExpiries: shiftExpiries,
        tickOption: tickOption,
        nextStrike: nextStrike,
        previousStrike: previousStrike,
        nextExpiry: nextExpiry,
        previousExpiry: previousExpiry,
        rollPosition: rollPosition
    }
}
